import { handleResponse, handleError } from "./apiUtils";

//const baseUrl = process.env.REACT_APP_GROUP_API_URL;
const urlGroupInfo = process.env.REACT_APP_GROUP_INFO_API_URL;
const urlGetGroupPlanContactTypes = process.env.REACT_APP_GET_GROUP_PLAN_CONTACT_TYPES_API_URL;
const urlGetGroupPlanContact = process.env.REACT_APP_GET_GROUP_PLAN_CONTACT_API_URL;
const urlSubmitGroupPlanContact = process.env.REACT_APP_SUBMIT_GROUP_PLAN_CONTACT_API_URL;
const urlGroupPlanLogin = process.env.REACT_APP_GROUP_PLAN_LOGIN_API_URL;
const urlGroupPlanDetails = process.env.REACT_APP_GROUP_PLAN_DETAILS_API_URL;
const urlGroupPlanBenefits = process.env.REACT_APP_GROUP_PLAN_BENEFITS_API_URL;
const urlGroupRenewalInfo = process.env.REACT_APP_GROUP_RENEWAL_INFO_API_URL;
const urlSubmitGroupRenewal = process.env.REACT_APP_SUBMIT_GROUP_RENEWAL_API_URL;
const urlSubmitGroupTermination = process.env.REACT_APP_SUBMIT_GROUP_TERMINATION_API_URL;
const urlSubmitNewGroupPlan = process.env.REACT_APP_SUBMIT_NEW_GROUP_PLAN_API_URL;
const env = process.env.REACT_APP_ENV;


export async function getPlanBenefits(planYear){


  try {
    let response = await fetch(`${urlGroupPlanBenefits}?planYear=${planYear}`, {
      mode: "cors",
      method: "GET",
      headers: { "content-type": "application/json" },
    });
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message || response.statusText);
    }

    const payload = await handleResponse(response);
    const rawBenefits = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.planBenefitStructures)
        ? payload.planBenefitStructures
        : Array.isArray(payload?.PlanBenefitStructures)
          ? payload.PlanBenefitStructures
          : [];

    return rawBenefits.map((benefit) => ({
      value: benefit?.value ?? benefit?.Value ?? "",
      text: benefit?.text ?? benefit?.Text ?? "",
    }));
  } catch (error) {
    return handleError(error);
  }
}

export async function groupPlanLogin(groupNumber, affiliatedPlanSponsor){


  try {
    let response = await fetch(urlGroupPlanLogin, {
      mode: "cors",
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ groupNumber, affiliatedPlanSponsor }),
    });
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message || response.statusText);
    }
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

export async function getGroupPlanDetails(groupNumber) {
  try {
    const params = new URLSearchParams({ groupNumber });
    const response = await fetch(`${urlGroupPlanDetails}?${params.toString()}`, {
      mode: "cors",
      method: "GET",
      headers: { "content-type": "application/json" },
    });

    const payload = await handleResponse(response);
    const group = payload?.groupPlan ?? payload?.GroupPlan ?? payload;
    return group;
  } catch (error) {
    return handleError(error);
  }
}

export async function getGroupRenewalInfo(groupNumber) {
  try {
    const params = new URLSearchParams({ groupNumber });
    const response = await fetch(`${urlGroupRenewalInfo}?${params.toString()}`, {
      mode: "cors",
      method: "GET",
      headers: { "content-type": "application/json" },
    });

    const payload = await handleResponse(response);
    const group = payload?.renewalInfo ?? payload;

    return group;
  } catch (error) {
    return handleError(error);
  }
}

export async function submitNewGroupPlan(payload) {

  // // 4/8/24 - disable API call for non-production environments
  // if (env === 'dev' || env === 'stage') {
  //   console.log('Verification disabled for environment: ' + env);
  //   return true;
  // }

  try {
    let response = await fetch(urlSubmitNewGroupPlan, {
      mode: "cors",
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      let errorMessage = "Network response was not ok.";
      try {
        const body = await response.json();
        errorMessage = body.message ?? JSON.stringify(body);
      } catch {
        errorMessage = await response.text().catch(() => errorMessage);
      }
      throw new Error(errorMessage);
    }
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

export async function submitGroupRenewal(payload) {

  // // 4/8/24 - disable API call for non-production environments
  // if (env === 'dev' || env === 'stage') {
  //   console.log('Verification disabled for environment: ' + env);
  //   return true;
  // }

  try {
    let response = await fetch(urlSubmitGroupRenewal, {
      mode: "cors",
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      let errorMessage = "Network response was not ok.";
      try {
        const body = await response.json();
        errorMessage = body.message ?? JSON.stringify(body);
      } catch {
        errorMessage = await response.text().catch(() => errorMessage);
      }
      throw new Error(errorMessage);
    }
    return; // Ok() returns no body
  } catch (error) {
    return handleError(error);
  }
}

export async function submitGroupTermination(payload) {

  // // 4/8/24 - disable API call for non-production environments
  // if (env === 'dev' || env === 'stage') {
  //   console.log('Verification disabled for environment: ' + env);
  //   return true;
  // }

  try {
    let response = await fetch(urlSubmitGroupTermination, {
      mode: "cors",
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      let errorMessage = "Network response was not ok.";
      try {
        const body = await response.json();
        errorMessage = body.message ?? JSON.stringify(body);
      } catch {
        errorMessage = await response.text().catch(() => errorMessage);
      }
      throw new Error(errorMessage);
    }
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}


export async function getGroupPlanContactTypes() {
  try {
    const response = await fetch(urlGetGroupPlanContactTypes, {
      mode: "cors",
      method: "GET",
      headers: { "content-type": "application/json" },
    });

    const payload = await handleResponse(response);
    const rawTypes = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.contactTypes)
        ? payload.contactTypes
        : Array.isArray(payload?.ContactTypes)
          ? payload.ContactTypes
          : [];

    return rawTypes.map((type) => ({
      value: type?.value ?? type?.Value ?? "",
      text: type?.text ?? type?.Text ?? "",
    }));
  } catch (error) {
    return handleError(error);
  }
}

export async function getGroupPlanContact(groupNumber) {
  try {
    const params = new URLSearchParams({ groupNumber });
    const response = await fetch(`${urlGetGroupPlanContact}?${params.toString()}`, {
      mode: "cors",
      method: "GET",
      headers: { "content-type": "application/json" },
    });

    const payload = await handleResponse(response);
    const rawContacts = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.contacts)
        ? payload.contacts
        : [];

    return rawContacts.map((contact) => ({
      groupNumber: contact?.groupNumber ?? groupNumber,
      contactId: contact?.contactId ?? null,
      contactTypeId: contact?.contactTypeId ?? "",
      contactReason: contact?.contactReason ?? "New",
      firstName: contact?.firstName ?? "",
      lastName: contact?.lastName ?? "",
      contactEffectiveDate: contact?.contactEffectiveDate ?? null,
      contactExpirationDate: contact?.contactExpirationDate ?? null,
      address1: contact?.address1 ?? "",
      address2: contact?.address2 ?? "",
      city: contact?.city ?? "",
      state: contact?.state ?? "",
      zip: contact?.zip ?? "",
      phoneNumber: contact?.phoneNumber ?? "",
      emailAddress: contact?.emailAddress ?? "",
    }));
  } catch (error) {
    return handleError(error);
  }
}

export async function submitGroupPlanContact(payload) {
  // // 4/8/24 - disable API call for non-production environments
  // if (env === 'dev' || env === 'stage') {
  //   console.log('Verification disabled for environment: ' + env);
  //   return true;
  // }

  try {
    let response = await fetch(urlSubmitGroupPlanContact, {
      mode: "cors",
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      let errorMessage = "Network response was not ok.";
      try {
        const body = await response.json();
        errorMessage = body.message ?? JSON.stringify(body);
      } catch {
        errorMessage = await response.text().catch(() => errorMessage);
      }
      throw new Error(errorMessage);
    }
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}
